function importAll(r) {
  return r.keys().map(r);
}

const projectImages = {
  'curse-of-the-nile': importAll(
    require.context('../assets/Curse of the Nile', false, /\.(jpeg|jpg|png)$/)
  ),
  deadzone: importAll(
    require.context('../assets/Deadzone', false, /\.(jpeg|jpg|png)$/)
  ),
  skywar: importAll(
    require.context('../assets/Skywar', false, /\.(jpeg|jpg|png)$/)
  ),
  'italian-hotel': importAll(
    require.context('../assets/Italian Hotel', false, /\.(jpeg|jpg|png)$/)
  ),
  fnaf: importAll(
    require.context('../assets/FNAF', false, /\.(jpeg|jpg|png)$/)
  ),
  'midnight-manor': importAll(
    require.context('../assets/Midnight Manor', false, /\.(jpeg|jpg|png)$/)
  ),
  locanda: importAll(
    require.context('../assets/Locanda', false, /\.(jpeg|jpg|png)$/)
  ),
};

export default projectImages;
